import { NetworkSpeed } from '../types';

export class NetworkDetector {
  private _speed: NetworkSpeed = 'fast';
  private _isOnline: boolean = true;

  onOnline: (() => void) | null = null;
  onOffline: (() => void) | null = null;

  initialize(): void {
    this._isOnline = navigator.onLine;

    window.addEventListener('online', () => {
      this._isOnline = true;
      if (this.onOnline) this.onOnline();
    });

    window.addEventListener('offline', () => {
      this._isOnline = false;
      this._speed = 'offline';
      if (this.onOffline) this.onOffline();
    });
  }

  async measureSpeed(testUrl?: string): Promise<NetworkSpeed> {
    if (!this._isOnline) {
      this._speed = 'offline';
      return 'offline';
    }

    try {
      const url = testUrl || '/audio/manifest.json';
      const startTime = performance.now();
      await fetch(url, { method: 'HEAD', cache: 'no-cache' });
      const ttfb = performance.now() - startTime;

      if (ttfb < 200) {
        this._speed = 'fast';
      } else if (ttfb < 500) {
        this._speed = 'medium';
      } else {
        this._speed = 'slow';
      }
    } catch {
      this._speed = 'slow';
    }

    return this._speed;
  }

  getSpeed(): NetworkSpeed {
    return this._speed;
  }

  isOnline(): boolean {
    return this._isOnline;
  }
}
